module.exports = "<transition name=\"modal\">\n\t<div class=\"modal-overlay\" v-bind:class=\"css\">\n\t\t<div class=\"modal-container\">\n\t\t\t<slot>please implement content</slot>\n\t\t</div>\n\t</div>\n</transition>";


//////////////////
// WEBPACK FOOTER
// ./static-content/public/javascripts/components/modal.html
// module id = 308
// module chunks = 0